
import './footer.scss';

function Footer() {
    return (
        <div className="footer">
            © 2026 passeazy 
        </div>
    );
};

export default Footer;